import { render, staticRenderFns } from "./sys_news_list.vue?vue&type=template&id=5f9483ee"
import script from "./sys_news_list.vue?vue&type=script&lang=js"
export * from "./sys_news_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JNproject\\qbyfdq-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9483ee')) {
      api.createRecord('5f9483ee', component.options)
    } else {
      api.reload('5f9483ee', component.options)
    }
    module.hot.accept("./sys_news_list.vue?vue&type=template&id=5f9483ee", function () {
      api.rerender('5f9483ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys_news_list.vue"
export default component.exports